import React, { useState, useContext, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Typography,
    Box,
    Snackbar,
    Alert,
    IconButton,
    Slide,
} from '@mui/material';
import { MessageSquarePlus, X } from 'lucide-react';
import { DASHBOARD_URL, BROADCAST_MSG_SAVE, BASIC_TOKEN_HEADER } from 'src/constants/api.config';
import { UserContext } from 'src/Contexts/UserContext';
import axios from 'axios';
import { notify } from 'src/utils/notifyFunction';
import { sanitizeInput, isInputSafe } from 'src/utils/sanitizeInput';
import { getUserToken } from 'src/utils/handleCookie';

export default function BroadcastMessage({ open, handleBroadCastClose, broadcastMessageFettcher, currentMessage }) {
    const [message, setMessage] = useState(currentMessage);
    const [showSuccess, setShowSuccess] = useState(false);
    const { contextUserData, setContextUserData } = useContext(UserContext)

    async function broadcastMessageSender(paramMessage) {

        const params = new URLSearchParams({
            Message: paramMessage,
            LoginID: getUserToken(),
        });
        const config = {
            method: "GET",
            url: `${DASHBOARD_URL}/${BROADCAST_MSG_SAVE}?${params.toString()}`,
            headers: BASIC_TOKEN_HEADER
        };

        try {
            const result = await axios(config);

            // setCurrentMessage(result.data.Links);

            if (result.data.ErrMsg[0].ErrCode === "1" && result.data.ErrMsg[0].ErrMsg) {
                // await broadcastMessageFettcher()
                notify(result.data.ErrMsg[0].ErrMsg, "success");
            }
        } catch (error) {
            // notify("Server Error", "error");
        }
    }


    const handleSubmit = async (e) => {
        e.preventDefault();

        // Input validation
        if (!isInputSafe(message)) {
            notify("Invalid input detected!", "error");
            return;
        }
        const safeMessage = sanitizeInput(message);
        await broadcastMessageSender(safeMessage)

        // Show success message
        setShowSuccess(true);

        // Reset form and close modal
        setMessage('');
        handleBroadCastClose();
    };

    useEffect(() => {

        setMessage(currentMessage[0]?.Message)
    }, [currentMessage])

    return (
        <>


            {/* Modal Dialog */}
            <Dialog
                open={open}
                onClose={handleBroadCastClose}
                maxWidth="md"
                TransitionComponent={Slide}
                transitionDuration={500}
                fullWidth
                TransitionProps={{
                    timeout: 400
                }}
                PaperProps={{
                    elevation: 8,
                    sx: { borderRadius: 2 }
                }}
            >
                <DialogTitle sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    borderBottom: '1px solid #eee',
                    pb: 1
                }}>
                    <Typography variant="h5" component="h2" sx={{ color: '#1976d2', fontWeight: 600 }}>
                        Create Broadcast Message
                    </Typography>
                    <IconButton onClick={handleBroadCastClose} size="small">
                        <X size={20} />
                    </IconButton>
                </DialogTitle>

                <DialogContent sx={{ pt: 3, pb: 2, mt: 5 }}>
                    <Box component="form" onSubmit={handleSubmit}>
                        <TextField
                            label="Message"
                            multiline
                            rows={5} // Adjust rows to dynamically set height
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            required
                            fullWidth
                            placeholder="Type your broadcast message here..."
                            variant="filled"
                            InputLabelProps={{
                                shrink: true, // Ensures the label does not overlap with the text
                            }}
                            sx={{
                                mb: 2,
                            }}
                        />


                    </Box>
                </DialogContent>

                <DialogActions sx={{ px: 3, pb: 3, pt: 1 }}>
                    <Button
                        onClick={handleBroadCastClose}
                        variant="outlined"
                        sx={{ mr: 1, textTransform: 'none', }}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleSubmit}
                        variant="contained"
                        disabled={!(message)}
                        sx={{
                            bgcolor: '#1976d2',
                            '&:hover': {
                                bgcolor: '#1565c0',
                            },
                            textTransform: 'none',
                        }}
                    >
                        Send Broadcast
                    </Button>
                </DialogActions>
            </Dialog>

            {/* <Snackbar
                open={showSuccess}
                autoHideDuration={6000}
                onClose={() => setShowSuccess(false)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert
                    onClose={() => setShowSuccess(false)}
                    severity="success"
                    sx={{ width: '100%' }}
                >
                    Broadcast message sent successfully!
                </Alert>
            </Snackbar> */}
        </>
    );
}